var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"no-body":""}},[_c('h4',{staticClass:"pl-1 pt-1"},[_vm._v("Restante")]),_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.items,"fields":_vm.fields,"small":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }